<template>
    <div>
        
        <el-row style="margin-bottom: 20px;">
        <el-col :lg="6" :offset="2">
        品牌: <el-tag type="info" effect="dark">{{this.orderChangeDetail.brand_id == 1 ? 'N牌':'S牌'}}</el-tag>
        
        </el-col>
        <el-col :lg="6" :offset="2">
        店櫃: <el-tag type="info" effect="dark">{{this.orderChangeDetail.shop_name}}</el-tag>
        
        </el-col>
        <el-col :lg="6">
            補單: <el-tag type="info" effect="dark">{{this.orderChangeDetail.makeup_doc == true ? '是': '否'}}</el-tag>
            
        </el-col>
        
    </el-row>
    <el-row style="margin-bottom: 20px;">
        <el-col :lg="6" :offset="2">
         日期: <el-tag type="info" effect="dark">{{this.orderChangeDetail.create_datetime}}</el-tag>
         
        
        </el-col>
        <el-col :lg="6" :offset="2">
        單號: <el-tag type="info" effect="dark">{{this.orderChangeDetail.id}}</el-tag>
        
        </el-col>
           <el-col :lg="6" >
       
        原訂單: <el-tag type="info" effect="dark">{{this.orderChangeDetail.order_id}}</el-tag>
        
        </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px;">
     
        <el-col :lg="6" :offset="2">
         
         姓名: <el-tag type="info" effect="dark">{{this.orderChangeDetail.member_name}}</el-tag>      
        </el-col>
        <el-col :lg="6" :offset="2">
            電話: <el-tag type="info" effect="dark">{{this.orderChangeDetail.phone}}</el-tag>
            
        </el-col>
        <el-col :lg="6" >
            卡號: <el-tag type="info" effect="dark">{{this.orderChangeDetail.card_number}}</el-tag>
            
        </el-col>
    </el-row>
    <hr />
    <el-row>
        <el-col :lg="6" :offset="2">
            折扣: <el-tag type="info" effect="dark">{{this.orderChangeDetail.discount_name}}</el-tag>
            
        </el-col>
        <el-col :lg="6" :offset="2">
            點數: <el-tag type="info" effect="dark">{{this.orderChangeDetail.get_point}}</el-tag>
            
        </el-col>
        <el-col :lg="6" :offset="0">
            建單: <el-tag type="info" effect="dark">{{this.orderChangeDetail.user_name}}</el-tag>
            
        </el-col>
        
    </el-row>
    
    <el-row>
        <el-col :lg="6" :offset="2">
             電子錢包: <el-tag type="info" effect="dark">{{this.orderChangeDetail.use_e_pay}}</el-tag>
        </el-col>
        <el-col :lg="6" :offset="2">
            現金: <el-tag type="info" effect="dark">{{this.orderChangeDetail.paid}}</el-tag>
            
        </el-col>
        <el-col :lg="6" :offset="0">
            總計: <el-tag type="info" effect="dark">{{this.orderChangeDetail.total}}</el-tag>
            
        </el-col>
        
    </el-row>
    <el-row>
        <el-col :lg="6" :offset="2">
             備註: <el-tag type="info" effect="dark">{{this.orderChangeDetail.note}}</el-tag>
        </el-col>
        <el-col :lg="18"></el-col>
    </el-row>
    
    
    <el-row>
        <el-col :lg="4" :offset="20">
             <el-button type="primary" size="default" @click="chreTab()" >退換貨記錄</el-button>
        </el-col>
    </el-row>
    
    <el-row style="margin-top: 20px;">
        <el-col :lg="11">
           原品項:
              <el-table
                  :data="forProductDetail"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="產品編號" prop="id">
                    
                  </el-table-column>
                  <el-table-column label="系列別" prop="className"></el-table-column>
                  <el-table-column
                      prop="name"
                      label="名稱"
                      >
                  </el-table-column>
                  <el-table-column label="數量" prop="qty">
                   
                  </el-table-column>
                  <el-table-column label="價格" prop="price" ></el-table-column>
                  <el-table-column label="實付價格" prop="paid" ></el-table-column>
              </el-table>
        </el-col>
        <el-col :lg="1">
        </el-col>
        <el-col :lg="11" :offset="1">
            換貨品項:
              <el-table
                  :data="toProductDetail"
                  style="width: 100%"
                  
                  
                  >
                  <el-table-column label="產品編號" prop="id">
                  
                  </el-table-column>
                  <el-table-column label="系列別" prop="className"></el-table-column>
                  <el-table-column
                      prop="name"
                      label="名稱"
                      >
                  </el-table-column>
                  <el-table-column label="數量" prop="qty">
                 
                  </el-table-column>
                  <el-table-column label="單價" prop="price" ></el-table-column>
                  <el-table-column label="小記" prop="paid" ></el-table-column>
              </el-table>
        </el-col>
    </el-row>
   
        <el-row style="margin-top: 20px;">
        <el-col :lg="11">
          
              <el-table
                  :data="shopPerformance"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="店櫃" prop="name">
                    
                  </el-table-column>
                  <el-table-column label="業績" prop="count"></el-table-column>
                
              </el-table>
        </el-col>
        <el-col :lg="1">
        </el-col>
        <el-col :lg="11" :offset="1">
          
              <el-table
                  :data="userPerformance"
                  style="width: 100%"
                 
                  
                  >
                  <el-table-column label="美容師" prop="name">
                  
                  </el-table-column>
                  <el-table-column label="業績" prop="count"></el-table-column>
                 
              </el-table>
        </el-col>
    </el-row>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'detail',
        props: {
            orderKey: String,
            orderTotal: Number
        },
        data() {
            return {
              orderChangeDetail: {},
              forProductDetail: [],  
              toProductDetail: [],
              forBundleDetail: [],
              toBundleDetail: [],
              forQtys: [],  
              toQtys: [],
               userPerformance: [],
                shopPerformance: []
            }
        },
        computed: mapGetters(["getOrderChangeDetail", "getProductDetail", "getUserPerformance", "getShopPerformance"]),
        methods: {
            ...mapActions(["fetchOrderChangeDetail", "fetchProductDetail"]),
            async fetchChangeDetail(){
                const data = {_key: this.orderKey}
                await this.$store.dispatch('fetchOrderChangeDetail', data)
                this.orderChangeDetail = this.getOrderChangeDetail
                this.userPerformance = this.getUserPerformance
                this.shopPerformance = this.getShopPerformance
                this.forFetchProduct(this.orderChangeDetail.change_items.from)
                this.toFetchProduct(this.orderChangeDetail.change_items.to)
              
            },
            async forFetchProduct(items){
             for (let i = 0; i < items.length; i++){
                  const data = {_key: items[i]._key, type: 1}
                  await this.$store.dispatch('fetchProductDetail', data)
                  this.forProductDetail.push({
                         name: items[i].name,
                      id: this.getProductDetail.id,
                      className: this.getProductDetail.class.name,
                      price: items[i].price,
                      paid: items[i].paid,
                      qty: items[i].qty
                  })
                
             }
            },
            async toFetchProduct(items){
             for (let i = 0; i < items.length; i++){
                  const data = {_key: items[i]._key, type: 1}
                  await this.$store.dispatch('fetchProductDetail', data)
                  this.toProductDetail.push({
                      name: this.getProductDetail.name,
                      id: this.getProductDetail.id,
                      className: this.getProductDetail.class.name,
                      price: items[i].price,
                      paid: items[i].paid,
                      qty: items[i].qty
                  })
                  this.toQtys.push(
                      items[i].qty
                  )
             }
            },
            async forFetchBundle(items){
                for(let i = 0;i < items.length; i++){
                    const data = {_key: items[i].from._key, type: 1}
                   await this.$store.dispatch('fetchProductDetail', data)
                   this.forBundleDetail.push({
                          name: this.getProductDetail.name,
                      id: this.getProductDetail.id,
                      className: this.getProductDetail.class.name,
                      price: this.getProductDetail.price,
                      qty: items[i].from.qty
                   })
                }
            },
            async toFetchBundle(items){
                for(let i = 0;i < items.length; i++){
                    const data = {_key: items[i].to._key, type: 1}
                   await this.$store.dispatch('fetchProductDetail', data)
                   this.forBundleDetail.push({
                          name: this.getProductDetail.name,
                      id: this.getProductDetail.id,
                      className: this.getProductDetail.class.name,
                      price: this.getProductDetail.price,
                      qty: items[i].to.qty
                   })
                }
            },
              chreTab(){
                this.$emit('chreListTabs', this.orderKey)
            },
        },
        created() {
            this.fetchChangeDetail()
        },
    }
</script>

<style lang="scss" scoped>
    
</style>